/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ParkingInputs */

const cs_enum_parking = /** @type {(inputs: Enum_ParkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parkování`)
};

const en_enum_parking = /** @type {(inputs: Enum_ParkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parking`)
};

/**
* | output |
* | --- |
* | "Parking" |
*
* @param {Enum_ParkingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_parking = /** @type {((inputs?: Enum_ParkingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ParkingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_parking(inputs)
	return cs_enum_parking(inputs)
});